import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  operatorData: null,
  masterModelData: null,
  systemData: null,
  tailData: null,
  componentData: null,
  parameterData: null,
  maintenanceStatusData: null,
  flightPhaseData: null,
  features: null,
  analytics: null,
  roles: null,
  modelData: null,
}

const getters = {
  operatorData() {
    return axios.get('/Lookups/airlines')
  },
  masterModelData() {
    return axios.get(`/MasterModel`)
  },
  systemData() {
    return axios.get(`/Lookups/systems`)
  },
  tailData() {
    return axios.get(`/Lookups/tails`)
  },
  componentData() {
    return axios.get(`/Lookups/components`)
  },
  parameterData() {
    return axios.get(`/Lookups/parameters`)
  },
  maintenanceStatusData() {
    return axios.get(`/Lookups/maintenancestatuses`)
  },
  flightPhaseData() {
    return axios.get(`/fleetcompare/flightphases`)
  },
  features() {
    return axios.get('/Lookups/Features')
  },
  analytics() {
    return axios.get('/Lookups/Analytics')
  },
  rolesData() {
    return axios.get(`/Lookups/roles`)
  },
  supportingInfoTypes() {
    return axios.get('/Lookups/supportinginformationtypes')
  },
  ataChaptersData() {
    return axios.get('/AtaChapter/chapters')
  },
  ataSubchaptersData() {
    return axios.get('/AtaChapter/subchapters')
  },
  modelData() {
    return axios.get('/model')
  },
  permissionsData() {
    return axios.get('/Lookups/permissions')
  },
}

export default class FullFlightService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
